<template>
  <div class="overall-progress">
    <custom-panel>
      <template #title>隐患警告级别分布</template>
      <template #default>
        <dv-capsule-chart :config="config" style="height: 100%;" v-if="dataLoaded"/>
      </template>
    </custom-panel>
  </div>
</template>

<script>
import CustomPanel from '../custom-panel/index.vue'
import request from '@/util/request.js'

export default {
  components: {
    CustomPanel
  },
  data () {
    return {
      timer: null,
      dataLoaded: false,
      config: {
        data: [],
        colors: [],
        unit: '数量',
        showValue: true
      }
    }
  },
  created () {
    this.getYinHuanJingGaoJiBieFenBu()
  },
  methods: {
    async getYinHuanJingGaoJiBieFenBu () {
      const res = await request.get('/common/yin-huan-jing-gao-ji-bie-fen-bu')
      this.config.data = res.data.map(item => {
        return {
          name: item.dangerLevelName,
          value: item.count
        }
      })
      this.config.colors = res.data.map(item => {
        return item.dangerLevelColor
      })
      this.dataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getYinHuanJingGaoJiBieFenBu()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.overall-progress {
  height: 100%;
}

:deep(.capsule-item-value) {
  padding-left: 8px;
}
</style>
